import type { AnchorStep } from '..';
import { StepBasePageObject } from '../../patterns/step/testing/step-base.pageobject';

/**
 * Page object for anchor steps
 */
export class AnchorStepPageObject extends StepBasePageObject<AnchorStep> {

}
